export const themes = {
    ADMINISTRATIVO: 'administrative',
    ASISTENCIAL: 'assistance'
}